import { createTheme } from "@mui/material";

export const theme = (btnColors) =>
  createTheme({
    typography: {
      fontFamily:
        "'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            padding: "1rem",
            fontWeight: "normal",
            textTransform: "unset",
          },
          containedPrimary: {
            backgroundColor: btnColors.btnPrimary,
            color: btnColors.btnFontPrimary,
            "&:hover": {
              backgroundColor: btnColors.btnPrimaryHover,
            },
          },
          containedSecondary: {
            backgroundColor: btnColors.btnSecondary,
            color: btnColors.btnFontSecondary,
            "&:hover": {
              backgroundColor: btnColors.btnSecondaryHover,
            },
          },
          text: {
            padding: "0 4px",
            width: "auto",
          },
          textPrimary: {
            color: btnColors.btnTextFontPrimary,
          },
          textSecondary: {
            color: btnColors.btnTextFontSecondary,
          },
        },
      },
    },
  });
